var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 3873 3873",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 519.882,
    x2: 3301.845,
    y1: 579.012,
    y2: 3360.976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fc00ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00dbde"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    fillRule: "evenodd",
    d: "M1018.3 3043h.2c0 98.3-79.9 180.5-180.7 180.5v.2c-98.8 0-180.5-80.3-180.5-180.7 0-100.1 81.4-180.7 180.5-180.7v.2c99.8 0 180.5 80.9 180.5 180.5zm1828.9-515.8c-17.1 5.7-35.3.5-47-11.7L2570 2285.1l-314.6 314.6 231.1 231.1c13.2 13.2 16.5 32.4 10.1 48.7-120.3 373.1 178.8 750.5 570.9 715.8l-268.4-268.4c-14-14-16.9-34.7-8.9-51.6l116.4-312.3-.2-.1c5.3-14.2 16.9-24.1 30.4-27.9l312.4-116.4-.1-.2c17.6-6.5 36.6-1.5 48.8 11.3l267.6 267.6c34.6-389.8-340.5-694-718.3-570.1zm-974.6-939.4-212.7-212.7-314.6 314.6 635.7 635.7 210.2 210.2 314.6-314.6c-15-15-606.2-606.3-633.2-633.2zm-548.2 612.3 359.8 359.8 200.8-202.3-359-359.1zm1426.5-658.8c58.3-21.9 121.1-30.9 187.4-26.5 381.1 25.1 692-299.1 651.8-678.2l-304.7 304.7c-12.1 12.8-31.2 17.8-48.8 11.3l.1-.2-347.2-129.4c-22.7-6.3-27.9-21.5-34.2-38.6l-125.4-336.6c-8-16.9-5.1-37.6 8.9-51.6l305.6-305.6c-381.1-40.4-703.2 272.8-678.2 651.8 4.4 66.3-4.6 129.1-26.5 187.4-36.7 97.5-98.7 152.3-105.1 160.1l356.4 356.4c40-43.8 104.4-84.1 159.9-105zm-223.8 169.5-356.7-356.7-201.6 201.6 357.5 357.5zM997.8 1385.4c19.5-6.1 36.9-7.2 53 9.7l230.4 230.4 314.6-314.6-231.1-231.1c-13.2-13.2-16.5-32.4-10.1-48.7 120.1-372.5-178.1-750.6-570.9-715.8L1052 583.7c14 14 16.9 34.7 8.9 51.6L944.5 947.7l.2.1c-5.3 14.2-16.9 24.1-30.4 27.9L601.9 1092l.1.2c-17.6 6.5-36.6 1.5-48.8-11.3L285.6 813.3c-34.5 389.5 338.6 689.7 712.2 572.1zm59.1 1082.1c-75.8 75.8-165.6 118.2-272.4 128.8-233.8 23.2-413.2 220.5-413.2 456.8 0 253.5 205.5 458.9 458.9 458.9 234.2 0 431.2-175.8 455.2-409.4 10.9-105.8 52.7-194.1 127.6-269.6l207.3-208.8-360.1-360.1zm52 575.5c0 150-121.3 271.2-271 271.2v-.2c-150.1 0-271.2-121.3-271.2-271s121.1-271 271.2-271v-.2c149.7 0 271.2 121.3 271.2 271.2z",
    clipRule: "evenodd",
    opacity: 1,
    "data-original": "url(#a)",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.f7a27a3911dc6de7f8dfa757a6258071.svg";
export { ForwardRef as ReactComponent };